import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Checkbox } from "../components/ui/checkbox";

const MLS_FRAMEWORK = [
  { title: "1 · The Hook", desc: "Lead with the home's #1 selling feature in the first 8 words — buyers scroll fast." },
  { title: "2 · The Story", desc: "Walk them through the home as if you're giving a tour — kitchen, primary, outdoor, neighborhood." },
  { title: "3 · The Specs", desc: "Beds, baths, sqft, lot, year, schools, HOA, upgrades — pack the keyword-rich details." },
  { title: "4 · The Call-to-Show", desc: "Close with urgency + clear next step: 'Schedule a private showing this weekend before this one is gone.'" },
];

export default function Listing() {
  const [items, setItems] = useState([]);

  useEffect(() => { api.get("/content/listing_check").then(r => setItems(r.data || [])); }, []);

  const pre = items.filter(i => i.phase === "pre-listing").sort((a, b) => a.order - b.order);
  const active = items.filter(i => i.phase === "active").sort((a, b) => a.order - b.order);

  return (
    <div className="space-y-8" data-testid="listing-page">
      <header>
        <div className="overline">Agent Playbook</div>
        <h1 className="font-heading text-5xl mt-2">Listing System</h1>
        <p className="text-sm text-[#050303]/60 mt-2">Pre-listing + active checklists, plus the 4-part MLS description framework.</p>
      </header>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <ChecklistCard title="Pre-Listing Checklist" items={pre} testId="pre-listing" />
        <ChecklistCard title="Active Listing Checklist" items={active} testId="active-listing" />
      </div>

      <section className="core-card p-7" data-testid="mls-framework">
        <div className="overline">MLS Description</div>
        <h3 className="font-heading text-2xl mt-1 mb-5">4-Part Framework</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {MLS_FRAMEWORK.map(f => (
            <div key={f.title} className="border-l-2 border-[#bf858e] pl-4">
              <div className="font-heading text-lg">{f.title}</div>
              <p className="text-sm text-[#050303]/75 mt-1 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

function ChecklistCard({ title, items, testId }) {
  const [done, setDone] = useState({});
  return (
    <div className="core-card p-7" data-testid={`checklist-${testId}`}>
      <h3 className="font-heading text-2xl mb-4">{title}</h3>
      <ul className="space-y-3">
        {items.map(i => (
          <li key={i.id} className="flex items-start gap-3">
            <Checkbox checked={!!done[i.id]} onCheckedChange={(v) => setDone(d => ({ ...d, [i.id]: !!v }))}
              data-testid={`check-${i.id}`}
              className="mt-0.5 data-[state=checked]:bg-[#050303] data-[state=checked]:border-[#050303]" />
            <span className={`text-sm ${done[i.id] ? "line-through text-[#050303]/40" : ""}`}>{i.title}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
